import { useCallback } from 'react';

export const useDealsClone = () => {
  const clone = useCallback(() => {
    throw new Error('"useDealsClone": the "Clone" action is deprecated, use "Use as template" instead.');
  }, []);

  return {
    clone,
  };
};
